var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AssetFolderIcon = function (_a) {
    var _b = _a.color1, color1 = _b === void 0 ? '#009983' : _b, _c = _a.color2, color2 = _c === void 0 ? '#52DECA' : _c, _d = _a.color3, color3 = _d === void 0 ? '#52DECA' : _d, props = __rest(_a, ["color1", "color2", "color3"]);
    return (_jsxs("svg", __assign({ width: '40', height: '40', viewBox: '0 0 40 40', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, props, { children: [_jsx("path", { d: 'M33.6004 6.99023H4.40039C3.29582 6.99023 2.40039 7.88566 2.40039 8.99023V22.5902C2.40039 23.6948 3.29582 24.5902 4.40039 24.5902H33.6004C34.705 24.5902 35.6004 23.6948 35.6004 22.5902V8.99023C35.6004 7.88566 34.705 6.99023 33.6004 6.99023Z', fill: color1 }), _jsx("path", { d: 'M35.6 10.1902H4.4C1.96995 10.1902 0 12.1602 0 14.5902V32.5902C0 35.0203 1.96995 36.9902 4.4 36.9902H35.6C38.0301 36.9902 40 35.0203 40 32.5902V14.5902C40 12.1602 38.0301 10.1902 35.6 10.1902Z', fill: color2 }), _jsx("path", { d: 'M15.6 2.99023H4.4C1.96995 2.99023 0 4.96018 0 7.39023V13.7902C0 16.2203 1.96995 18.1902 4.4 18.1902H15.6C18.0301 18.1902 20 16.2203 20 13.7902V7.39023C20 4.96018 18.0301 2.99023 15.6 2.99023Z', fill: color3 })] })));
};
export default AssetFolderIcon;
